export const NICE_TO_HAVE_COLOR = 'var(--static-data-vis-purple-vis-purple-60)';

export const MUST_HAVE_COLOR = 'var(--static-data-vis-purple-vis-purple-120)';

export const NOT_INTERESTED_COLOR = 'var(--static-data-vis-teal-vis-teal-100)';

export const IMPORTANCES = [
    {
        id: 2,
        label: 'Must have',
        color: MUST_HAVE_COLOR,
    },
    {
        id: 1,
        label: 'Nice to have',
        color: NICE_TO_HAVE_COLOR,
    },
    {
        id: -1,
        label: 'Not interested',
        color: NOT_INTERESTED_COLOR,
    },
];

export const FEEDBACK_IMPORTANCES = [
    {
        id: 2,
        label: 'Must have',
        color: MUST_HAVE_COLOR,
    },
    {
        id: 1,
        label: 'Nice to have',
        color: NICE_TO_HAVE_COLOR,
    },
];

export const ERROR_STATES = {
    NOT_FOUND: 'notFound',
    FORBIDDEN: 'forbidden',
    INSUFFICIENT_DATA: 'insufficientData',
    DELETED_SEGMENT: 'deletedSegment',
};

export const DEFAULT_FEEDBACK_TAB = 'insights';

export const DEFAULT_FEEDBACK_TAB_V2 = 'overview';

export const EFFORT_IMPACT_OPTIONS = [
    {
        id: 1,
        label: 'XS',
    },
    {
        id: 2,
        label: 'S',
    },
    {
        id: 3,
        label: 'M',
    },
    {
        id: 4,
        label: 'L',
    },
    {
        id: 5,
        label: 'XL',
    },
];

export const MINIMUM_NUMBER_OF_ITEMS_FOR_SUMMARY = 5;

export const DISCOVER_ROLE_OPTIONS = [
    {
        id: 'feedback-manager',
        label: 'Manage the feedback program for my organization',
        description: 'Typically Customer Experience, Product Operations, User Experience',
    },
    {
        id: 'product-manager',
        label: 'Product manage an app or product area',
        description: 'Typically Product Managers, Designers and Researchers',
    },
    {
        id: 'customer-relations',
        label: 'Manage customer relationships',
        description: 'Typically Customer Success, Customer Experience or Sales',
    },
];

export const REFLOW_TIMEOUT = 500;

export const EMPTY_RULE = {
    name: '',
    description: '',
    enabled: true,
    applyMatchingItems: false,
    conditionConfig: {
        data: [],
    },
    actionConfig: {},
};

export const NO_CATEGORY_STRING = '(No Category)';

export const DEFAULT_VOC_PORTALS_TAB = 'settings';

export const SYNC_STATUS_ORDER = {
    'failed': -1,
    'not started': 0,
    'in progress': 0,
    'preparing': 0,
    'complete': 1,
    '': 1,
};

export const EMPTY_IDENTITY = {
    friendlyFromName: '',
    domain: '',
    from: '',
    replyTo: '',
    id: '',
};

export const EMPTY_DEFAULT_IDENTITY = {
    ...EMPTY_IDENTITY,
    isDefault: true,
};

export const CROPPER_MAX_ZOOM = 0.9997123375275616;

export const CAROUSEL_TIPS = [
    {
        id: 1,
        heading: 'Did you know...',
        text:
            "Alongside customer feedback, Pendo Listen offers a central location for creating and managing product ideas and the ability to link feedback data to these ideas, giving you a sense of what's most important to customers.",
    },
    {
        id: 2,
        heading: 'Make sure you try idea validation!',
        text: 'Use Validate to test and prioritize ideas so that you can give your customers what they want and need.',
    },
    {
        id: 3,
        heading: 'Feedback capture in Pendo Listen',
        text:
            'Pendo Listen offers a central location for collecting and acknowledging customer feedback. Create saved views of feedback data to return to later.',
    },
    {
        id: 4,
        heading: 'Roadmapping tip!',
        text:
            'Promote ideas in Validate to features in Roadmaps that you can then use to communicate with stakeholders.',
    },
    {
        id: 5,
        heading: 'Create feedback views!',
        text:
            'Focus on the feedback that matters most to you. Each view you create will provide a curated summary, trends, and charts to quickly extract insights.',
    },
];

export const FREEMIUM_STATUS = {
    DISABLED: 'disabled',
    READY: 'ready',
    PROCESSING: 'processing',
    ENABLED: 'enabled',
};
